import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { useEditInvitedCompanyNameModal } from '@/components/misc/EditInvitedCompanyNameButton/EditInvitedCompanyNameModal/useEditInvitedCompanyNameModal'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { faPencil } from '@/lib/fontAwesomePro/light'
import { cn } from '@/lib/utils'
import { PanelInviteSource } from '@/types/misc'

type Props = {
  className?: string
  panelInvite: {
    companyName: string
    hasCustomCompanyName: boolean
    source: PanelInviteSource
    sourceId: number
  }
}

const EditInvitedCompanyNameButton: React.FC<Props> = ({
  panelInvite,
  className,
}) => {
  const { showModal } = useEditInvitedCompanyNameModal()

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <FontAwesomeIcon
          className={cn(
            `text-primary hover:bg-primary relative cursor-pointer p-2.5
            text-[11px] hover:text-white`,
            className,
          )}
          icon={faPencil}
          onClick={(event) => {
            event.stopPropagation()
            event.preventDefault()

            showModal({
              companyName: panelInvite.companyName,
              source: panelInvite.source,
              sourceId: panelInvite.sourceId,
            })
          }}
        />
      </TooltipTrigger>

      <TooltipContent>
        {panelInvite.hasCustomCompanyName
          ? 'Edit temporary company name'
          : 'Set temporary company name'}
      </TooltipContent>
    </Tooltip>
  )
}

export default EditInvitedCompanyNameButton
